// Tray Layout constants
export const SPACE_AROUND_IN_CALL_MODAL_REM = 0;
export const BOTTOM_ROW_ELEMENT_HEIGHT_REM = 3.875; // rem
export const BOTTOM_ROW_ELEMENT_MARGIN_TOP_REM = 0.5; // rem
export const BOTTOM_ROW_ELEMENT_MARGIN_BOTTOM_REM = 0.5; // rem
export const BOTTOM_ROW_HEIGHT_REM = BOTTOM_ROW_ELEMENT_HEIGHT_REM +
    BOTTOM_ROW_ELEMENT_MARGIN_BOTTOM_REM +
    BOTTOM_ROW_ELEMENT_MARGIN_TOP_REM;
// button constants
export const ROUNDED_BUTTON_PADDING = '0.875rem';
export const ROUNDED_BUTTON_BORDER_RADIUS = '5rem';
export const STANDARD_BUTTON_BORDER_RADIUS = '.5rem';
//# sourceMappingURL=constants.js.map